// extracted by mini-css-extract-plugin
export default {"UpsellBannerOcticon":"UpsellBanner-module__UpsellBannerOcticon--bEPlc","UpsellBannerHeading":"UpsellBanner-module__UpsellBannerHeading--GW0xL"};